import { createAsyncThunk } from "@reduxjs/toolkit";
import { NormalizedCostWidgetSetupType } from "@/store/dashboards/utils/types/setups/normalizedCostWidgetSetupType";
import { RootState } from "@/store/store";
import { isDeepEqual } from "@/utils/is-deep-equal";
import { normalizedCostWidgetSetupSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupSelector";
import { setWidgetSetup } from "@/store/dashboards/dashboardsSlice";
import { getNormalizedCostWidgetSetupDataThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/getNormalizedCostWidgetSetupDataThunk";

export const normalizedCostWidgetSetupDataChangeThunk = createAsyncThunk(
  "dashboards/normalizedCostWidgetSetupDataChange",
  async (
    data: Partial<NormalizedCostWidgetSetupType>,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const existingSetup = normalizedCostWidgetSetupSelector(state);

    if (!existingSetup || isDeepEqual(existingSetup, data)) {
      return;
    }

    dispatch(setWidgetSetup({ ...existingSetup, ...data }));

    dispatch(getNormalizedCostWidgetSetupDataThunk());
  },
);
